import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { GreyButton } from 'components/Button'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'

const PointCardEditCompleteTemplate: FC = () => {
  const dispatch = useDispatch()
  const handleConfirmPointCard = () => {
    dispatch(push('/point_card'))
  }
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/point_card.svg'} alt={''} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          ポイントカードの作成が
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <GreyButton
        label={'ポイントカードを確認する'}
        onClick={handleConfirmPointCard}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={72} />
    </div>
  )
}

export default PointCardEditCompleteTemplate
